/* eslint-disable default-case */
/* eslint-disable no-case-declarations */
/* eslint-disable no-shadow */
/* eslint-disable react/jsx-curly-newline */
import React from 'react';

// import { MdClose } from 'react-icons/md';
// import Skeleton from 'react-loading-skeleton';

// import { useDispatch, useSelector } from 'react-redux';
// import { useHistory } from 'react-router-dom';
// import {
//   Root,
//   ContainerMyCart,
//   MyCartTitle,
//   ProductsList,
//   ProductRow,
//   ContainerImagem,
//   ProductImagem,
//   ContainerDetal,
//   ProductTitle,
//   ProductCategory,
//   ProductPrice,
//   ContainerQty,
//   QtyTitle,
//   Botton,
//   CotainerActions,
//   PlusIcon,
//   InputQty,
//   ContainerRemove,
//   ButtonRemove,
//   ContainerActions,
//   KeepBuyingBtn,
//   VoidedBtn,
//   FinishBtn,
// } from './styles';
// import CardPayment from '../../components/CardPayment';
// import CardAddress from '../../components/CardAddress';
// import { StoreState } from '../../store/createStore';
// import { routesEndpoints } from '../../routes/endpoint';
// import {
//   checkoutActionTypes,
//   checkoutDataSuccess,
//   checkoutProductProps,
// } from '../../store/modules/checkout/types';
// import {
//   checkoutRemovePlu,
//   clearError,
//   closeSale,
// } from '../../store/modules/checkout/actions';
// import { setIsCategory, setMessageToast } from '../../store/modules/parameter/actions';
// import { FiTrash2 } from 'react-icons/fi';
// import { AiOutlineMinus } from 'react-icons/ai';
// import { useTranslation } from '../../hooks/useTranslation';

const Summary: React.FC = () => {
  // const history = useHistory();
  // const dispatch = useDispatch();
  // useEffect(() => {
  //   dispatch(setIsCategory(false));
  // }, [dispatch]);

  // const {
  //   user,
  //   user: { methods },
  // } = useSelector((state: StoreState) => state.auth);

  // const { summary, loading, error, errorData, } = useSelector(
  //   (state: StoreState) => state.checkout,
  // );
  // const {onTranslation : t} = useTranslation();

  // useEffect(() => {
  //   //konsole.log('Closed..', error, errorData);
  //   if (error && errorData) {
  //     history.push(routesEndpoints.ACCOUNT_PAYMENT);
  //     dispatch(setMessageToast('warning', errorData.message));
  //     dispatch(clearError());
  //   }
  // }, [error, errorData, dispatch, history]);

  // useEffect(() => {
  //   if (user_not_address === true) {
  //     history.push(routesEndpoints.ACCOUNT_ADDRESS);
  //     dispatch(setMessageToast('warning', t('main.messages_toast.create_address_first')));
  //   }
  // }, [user_not_address, history, dispatch, t]);

  // useEffect(() => {
  //   if (methods && methods?.length === 0) {
  //     history.push(routesEndpoints.ACCOUNT_PAYMENT);
  //     dispatch(setMessageToast('warning', t('main.messages_toast.create_method_first')));
  //   }
  // }, [methods, history, dispatch, t]);

  // const handleActions = useCallback(
  //   async (
  //     type: string,
  //     product?: checkoutProductProps,
  //     summary?: checkoutDataSuccess,
  //   ) => {
  //     switch (type) {
  //       case checkoutActionTypes.CLOSE_SALE:
  //         if (summary?.id) {
  //           await dispatch(closeSale(summary?.id, summary, user));
  //         }
  //         break;
  //       case checkoutActionTypes.PLUS_PLU_QTY_CHECKOUT:
  //         if (summary?.id && product) {
  //           dispatch(checkoutPlusQtyPlu(summary?.id, product));
  //         }
  //         break;
  //       case checkoutActionTypes.MINUS_PLU_QTY_CHECKOUT:
  //         if (summary?.id && product) {
  //           dispatch(checkoutMinusQtyPlu(summary?.id, product));
  //         }
  //         break;
  //       case checkoutActionTypes.REMOVE_PLU_CHECKOUT:
  //         if (summary?.id && product) {
  //           dispatch(checkoutRemovePlu(summary?.id, product));
  //         }
  //         break;
  //     }
  //   },
  //   [user, dispatch],
  // );

  // useEffect(() => {
  //   //konsole.log('summary?.order_save: ', summary?.order_save);
  //   if (summary?.order_save === true)
  //     history.push(routesEndpoints.SUMMARY_FINISH);
  // }, [summary, history]);

  // return (
  //   <Root>
  //     <ContainerMyCart>
  //       <>
  //         {loading ? (
  //           <>
  //             <MyCartTitle>
  //               <span>
  //                 Pedido #
  //                 <>
  //                   <Skeleton duration={1} width={53} height={29} key="1" />
  //                 </>
  //               </span>
  //             </MyCartTitle>
  //             <ProductsList>
  //               <ProductRow key="1">
  //                 <Skeleton duration={1} width={1490} height={120} key="2" />
  //               </ProductRow>
  //               <ProductRow key="2">
  //                 <Skeleton duration={1} width={1490} height={120} key="3" />
  //               </ProductRow>
  //             </ProductsList>
  //           </>
  //         ) : (
  //           <>
  //             {error && errorData && (
  //               <>
  //                 <h1 style={{ color: '#000' }}>{errorData.message}</h1>
  //               </>
  //             )}
  //             <MyCartTitle>
  //               <>
  //                 {!summary?.id || !summary.items?.length ? (
  //                   <span>Pedido vazio :( </span>
  //                 ) : (
  //                   <span>Pedido # {summary?.id}</span>
  //                 )}
  //               </>
  //             </MyCartTitle>
  //             <ProductsList>
  //               {summary?.items &&
  //                 summary.items.map(item => (
  //                     <ProductRow key={item.cart_item_id}>
  //                       <ContainerImagem>
  //                         <ProductImagem>
  //                           <img
  //                             src={item.product && item.product.image_url}
  //                             alt={item.short_description}
  //                           />
  //                         </ProductImagem>
  //                       </ContainerImagem>
  //                       <ContainerDetal>
  //                         <ProductTitle>
  //                           <span>{item.short_description}</span>
  //                         </ProductTitle>
  //                         <ProductCategory>
  //                           {item.product && item.product.category ? (
  //                             <span>{item.product.category.long_description}</span>
  //                           ) : (
  //                             <span />
  //                           )}
  //                         </ProductCategory>
  //                         <ProductPrice>
  //                           <span> {Number(item.price).toFixed(2)}</span>
  //                         </ProductPrice>
  //                       </ContainerDetal>
  //                       <ContainerQty>
  //                         <QtyTitle>
  //                           <span>Quantidade</span>
  //                         </QtyTitle>
  //                         <CotainerActions>
  //                           <Botton
  //                             onClick={() =>
  //                               handleActions(
  //                                 checkoutActionTypes.PLUS_PLU_QTY_CHECKOUT,
  //                                 {
  //                                   ...item,
  //                                 },
  //                                 summary,
  //                               )
  //                             }
  //                           >
  //                             <PlusIcon size={24} />
  //                           </Botton>
  //                           <InputQty
  //                             value={Number(item.quantity).toFixed(0)}
  //                           />
  //                           <Botton
  //                             onClick={() =>
  //                               handleActions(
  //                                 checkoutActionTypes.MINUS_PLU_QTY_CHECKOUT,
  //                                 {
  //                                   ...item,
  //                                 },
  //                                 summary,
  //                               )
  //                             }
  //                           >
  //                             {Number(item.quantity) === 1 ?
  //                               <FiTrash2 color="red" /> :
  //                               <AiOutlineMinus />
  //                             }
  //                           </Botton>
  //                         </CotainerActions>
  //                       </ContainerQty>
  //                       <ContainerRemove>
  //                         <ButtonRemove
  //                           onClick={() =>
  //                             handleActions(
  //                               checkoutActionTypes.REMOVE_PLU_CHECKOUT,
  //                               {
  //                                 ...item,
  //                               },
  //                               summary,
  //                             )
  //                           }
  //                         >
  //                           <span>EXCLUIR PRODUTO</span>
  //                           <MdClose color="#FFF" />
  //                         </ButtonRemove>
  //                       </ContainerRemove>
  //                     </ProductRow>
  //                 ))}
  //             </ProductsList>
  //           </>
  //         )}
  //       </>
  //     </ContainerMyCart>

  //     {!summary?.id || !summary.items?.length ? (
  //       <>
  //         <ContainerActions>
  //           <KeepBuyingBtn onClick={() => history.push(routesEndpoints.HOME)}>
  //             <span>CONTINUAR COMPRANDO</span>
  //           </KeepBuyingBtn>
  //           {/* <VoidedBtn onClick={() => konsole.log('clicou...')}> */}
  //           <VoidedBtn>
  //             <span>CANCELAR COMPRA</span>
  //           </VoidedBtn>
  //         </ContainerActions>
  //       </>
  //     ) : (
  //       <>
  //         <CardPayment title="Forma de Pagamento" summary />
  //         <br />
  //         <CardAddress title="Endereço de Entrega" summary />
  //         <ContainerActions>
  //           <FinishBtn
  //             disabled={!summary?.id}
  //             onClick={() =>
  //               !loading &&
  //               handleActions(
  //                 checkoutActionTypes.CLOSE_SALE,
  //                 {},
  //                 summary,
  //               )
  //             }
  //           >
  //             <span> {loading ? 'Aguarde...' : 'FINALIZAR COMPRA'}</span>
  //           </FinishBtn>
  //         </ContainerActions>

  //         <ContainerActions>
  //           <KeepBuyingBtn onClick={() => history.push(routesEndpoints.HOME)}>
  //             <span>CONTINUAR COMPRANDO</span>
  //           </KeepBuyingBtn>
  //           {/* <VoidedBtn onClick={() => konsole.log('clicou...')}> */}
  //           <VoidedBtn>
  //             <span>CANCELAR COMPRA</span>
  //           </VoidedBtn>
  //         </ContainerActions>
  //       </>
  //     )}


  //   </Root>
  // );
  return (
    <>
    Desativado
    </>
  )
};

export default Summary;
